import React from "react";
import { styled } from "styled-components";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Wrapper = styled.div`
  background-image: url("img/teacher-background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;
`;

const ClassesStyled = styled.div`
  display: grid;
  gap: 30px;
  width: 100%;
  grid-template-columns: 1fr;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    align-items: center;
    & img {
      height: auto;
    }
  }
`;

const TeacherInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  & .teacherText {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & p {
      margin: 0;
    }

    & a {
      text-decoration: none;
    }
  }
`;

const TeacherWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 400px;
  margin: auto;
`;

const LinkedInWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue};
  gap: 5px;
`;

const ParagraphStyled = styled.p`
  font-size: 300;
  font-size: 14px;
`;

export const Teachers = () => {
  return (
    <Wrapper>
      <Content>
        <Subtitle>Aprende de quienes están creando el futuro digital</Subtitle>
        <Title>
          Profesores que viven lo que enseñan:
          <br />
          desarrolladores en activo con experiencia real
        </Title>
        <ClassesStyled>
          <div>
            <p>
              Nuestros profesores no solo te enseñan teoría; te transmiten su
              experiencia directa del mundo laboral.
            </p>
            <p>
              Son <b>profesionales en activo</b> que compaginan su día a día
              como desarrolladores de software con la pasión de formar a la
              próxima generación de talentos.{" "}
            </p>
            <p>
              Gracias a su conocimiento actualizado y su conexión con la
              industria, aprenderás las tecnologías, metodologías y buenas
              prácticas que realmente se usan en el mercado.{" "}
            </p>
            <p>
              Con ellos, no solo estudiarás desarrollo web;{" "}
              <b>vivirás la realidad del sector</b> desde el primer día.
            </p>
          </div>
          <TeacherWrapper>
            <TeacherInfo>
              <img src="/img/roxana.png" />
              <div className="teacherText">
                <p style={{ fontWeight: 600, fontSize: 20 }}>Roxana Lorint</p>
                <ParagraphStyled>
                  Desarrolladora Frontend en Cognizant
                </ParagraphStyled>
                <a
                  href="https://www.linkedin.com/in/roxana-cestari-58341560/"
                  target="_blank"
                >
                  <LinkedInWrapper>
                    <LinkedInIcon />
                    <ParagraphStyled>/roxana-cestari-58341560/</ParagraphStyled>
                  </LinkedInWrapper>
                </a>
              </div>
            </TeacherInfo>
            <TeacherInfo>
              <img src="/img/ivan.png" />
              <div className="teacherText">
                <p style={{ fontWeight: 600, fontSize: 20 }}>Iván Herranz</p>
                <ParagraphStyled>
                  Desarrollador Frontend en ERNI
                </ParagraphStyled>
                <a
                  href="https://www.linkedin.com/in/ivanherranzcuesta/"
                  target="_blank"
                >
                  <LinkedInWrapper>
                    <LinkedInIcon />
                    <ParagraphStyled>/ivanherranzcuesta</ParagraphStyled>
                  </LinkedInWrapper>
                </a>
              </div>
            </TeacherInfo>
          </TeacherWrapper>
        </ClassesStyled>
        <span id="students"></span>
      </Content>
    </Wrapper>
  );
};
